<template>
  <div class="h-full">
    <TopAppBar
      :leftBtnMethod="leftBtnMethod"
      :leftBtnMode="leftBtnMode"
      :rightBtnMethod="rightBtnMethod"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :hideCategory="false"
      staticMode="true"
    />

    <div
      class="d-flex flex-column main-wrapper flex-grow-1 container container--narrow h-full pdl-0"
    >
      <TopAppBarDrawer></TopAppBarDrawer>
      <div class="d-flex align-items-center bg-white fix-header-title">
        <div
          class="t-headline13 t-color-headlineBlack pda-14 t-center flex-grow-1"
        >
          <div class="font-m">{{ this.$t("3794") }}</div>
        </div>
      </div>
      <div class="divider"></div>

      <div class="t-headline9 mt3 pdt-16">
        {{ $t("3795") }}
      </div>
      <div class="t-body3 mgt-6 t-color-bodyGrayA">
        {{ $t("3796") }}
      </div>

      <!-- 사유 선택 -->
      <div class="mgt-24">
        <div
          v-for="(item, i) in list"
          :key="i"
          class="pda-16 pdt-14 pdb-14 mgb-8 b-radius4"
          :class="item.value === selected ? 'bg-quizBlack' : 'bg-quizGray'"
        >
          <div class="mdc-form-field" v-if="item.value !== 'OTHERS'">
            <div class="mdc-radio radio-white">
              <input
                class="mdc-radio__native-control"
                type="radio"
                :value="item.value === selected"
                :id="`radio_${item.value}`"
                @click="setSelected(item.value)"
                @keypress="setSelected(item.value)"
                tabindex="0"
                name="reason"
              />
              <div class="mdc-radio__background">
                <div class="mdc-radio__outer-circle"></div>
                <div class="mdc-radio__inner-circle"></div>
              </div>
            </div>
            <label
              :for="`radio_${item.value}`"
              class="t-body1"
              :class="
                item.value === selected
                  ? 't-color-whiteHigh2'
                  : 't-color-quizBlack'
              "
            >
              {{ handleLangWithdrawList(item.value) }}
            </label>
          </div>

          <!-- 기타 사유 -->
          <div
            v-else
            class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full align-items-center pda-0"
          >
            <div class="mdc-radio radio-white">
              <input
                class="mdc-radio__native-control"
                type="radio"
                :value="selected === 4"
                :id="`radio_${4}`"
                @click="setSelected(item.value, 'ETC')"
                @keypress="setSelected(item.value, 'ETC')"
                tabindex="0"
                name="reason"
              />
              <div class="mdc-radio__background">
                <div class="mdc-radio__outer-circle"></div>
                <div class="mdc-radio__inner-circle"></div>
              </div>
            </div>
            <div
              class="d-flex flex-column mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
              :class="[
                { 'mdc-text-field--invalid': !commentValidation },
                { 'mdc-text-field--disabled': !selectedEtc },
              ]"
              id="reason-input"
            >
              <i class="material-icons mdc-text-field__icon">
                {{ validIcon }}
              </i>
              <input
                type="text"
                class="mdc-text-field__input input-color"
                maxlength="100"
                autocomplete="off"
                :value="comment"
                @input="handleComment"
                :disabled="!selectedEtc"
              />
              <div class="mdc-notched-outline">
                <div
                  class="mdc-notched-outline__leading"
                  :class="{ 'selected-outline': selected === 'OTHERS' }"
                ></div>
                <div
                  class="mdc-notched-outline__notch"
                  :class="{ 'selected-outline': selected === 'OTHERS' }"
                >
                  <label
                    for="tf-outlined"
                    class="mdc-floating-label"
                    :class="
                      selected === 'OTHERS'
                        ? 't-color-whiteHigh2'
                        : selected === 'OTHERS' && !commentValidation
                        ? 't-color-secondaryBtnText'
                        : ''
                    "
                  >
                    {{ $t("3802") }}
                  </label>
                </div>
                <div
                  class="mdc-notched-outline__trailing"
                  :class="{ 'selected-outline': selected === 'OTHERS' }"
                ></div>
              </div>
              <div
                class="pdl-10 mgt-1 t-helper text-helper t-color-textfieldActive"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div class="mgt-50">
        <button
          class="mdc-button mdc-button--raised btn-red mr8 bg-mainBtn"
          @click="next"
          @keypress="next"
        >
          {{ $t("3804") }}
        </button>
        <button
          class="mdc-button btn-white t-color-secondaryBtnText"
          @click="handleClose()"
          @keypress="handleClose()"
          type="button"
          tabindex="0"
        >
          {{ $t("3805") }}
        </button>
      </div>
    </div>
  </div>
</template>
    
<script>
import { MDCTextField } from "@material/textfield";
import { MDCRipple } from "@material/ripple";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import { fileMixin } from "@/mixins/file";
import { userMixin } from "@/mixins/user";
import memberApi from "@/api/memberApi";
import boardApi from "@/api/boardApi";
import degreeApi from "@/api/degreeApi";
import microDegreeApi from "@/api/microDegreeApi";
import checklistApi from "@/api/checklistApi";

export default {
  name: "ReasonChoice",

  components: {
    TopAppBar: () => import("@/components/TopAppBar.vue"),
    TopAppBarDrawer: () => import("@/components/TopAppBarDrawer.vue"),
  },

  mixins: [topAppBarMixin, fileMixin, userMixin],

  data() {
    return {
      data: null,
      list: null,
      selected: null,
      selectedEtc: false,
      comment: "",
      commentTextField: "",
      validIcon: "",
      commentValidation: true,
    };
  },

  watch: {
    selectedEtc: function (val) {
      if (!val) {
        this.handleCommentValidation();
      }

      const el = document.querySelector(".mdc-text-field--disabled");
      if (el && val) {
        el.classList.remove("mdc-text-field--disabled");
      }

      const inputNotchEl = document.querySelector(
        ".mdc-notched-outline--notched"
      );
      if (inputNotchEl && !val) {
        inputNotchEl.classList.remove("mdc-notched-outline--notched");
      }
    },
  },

  mounted() {
    if (this.$route.params.data) {
      this.data = this.$route.params.data;
    } else {
      this.$router.go(-1);
    }
    this.getList();
  },

  updated() {
    this.setMaterialUi();
  },

  methods: {
    setMaterialUi() {
      const reasonInput = document.querySelector("#reason-input");
      const mdcButtonClass = document.querySelectorAll(".mdc-button");
      if (reasonInput) {
        this.commentTextField = new MDCTextField(reasonInput);
        this.commentTextField.useNativeValidation = false;
        const buttonRipple = [].map.call(mdcButtonClass, function (el) {
          let button = new MDCRipple.attachTo(el);
          return button;
        });
      }
    },

    handleComment(e) {
      this.comment = e.target.value;
      if (this.comment.length) {
        this.handleCommentValidation();
      }
    },

    handleCommentValidation() {
      this.commentValidation = !(this.comment.length === 0 && this.selectedEtc);
    },

    handleClose() {
      this.$router.go(-1);
    },

    // 사유 리스트 다국어 처리
    handleLangWithdrawList(value) {
      switch (value) {
        case "SPAM":
          return this.$t("3797");

        case "CURSE":
          return this.$t("3798");

        case "COPYRIGHT_INFRINGE":
          return this.$t("3799");

        case "PERSONAL_INFO":
          return this.$t("3800");

        case "IRRELEVANT_CONTENTS":
          return this.$t("3801");

        default:
          break;
      }
    },

    // GET : 사유 리스트
    async getList() {
      try {
        const listResult = await memberApi.getReportReasonList();
        if (listResult) {
          const responseList = listResult.data.data;
          const filteredResponseList = responseList.filter((listItem) => {
            if (listItem.value && listItem.customValues.scope !== "ADMIN") {
              return listItem;
            }
          });
          this.list = filteredResponseList;
        }
      } catch (error) {
        console.log("GET LIST ERR : ", error);
      }
    },

    // 답안 설정(set answer)
    setSelected(value, type) {
      if (type === "ETC") {
        this.selectedEtc = true;
      } else {
        this.selectedEtc = false;
        this.comment = "";
      }
      this.selected = value;
    },

    // 다음 처리
    async next() {
      if (this.selected === null) {
        this.handleCommentValidation();
        return this.$snackOpen({
          contents: this.$t("3806"),
        });
      }

      if (this.selected === "OTHERS" && this.comment.length === 0) {
        this.handleCommentValidation();
        return this.$snackOpen({
          contents: this.$t("3876"),
        });
      }

      const confirmResult = await this.$confirm({
        title: this.$t("3790"),
        content: this.$t("3791"),
        accept: this.$t("3792"),
        cancel: this.$t("3793"),
      });

      if (confirmResult) {
        const params = {
          reason: {},
        };
        if (this.selected === "OTHERS" && this.comment.length > 0) {
          params.comment = this.comment;
        }
        const selected = this.list.find(
          (listItem) => listItem.value === this.selected
        );
        params.reason = selected;

        try {
          // 요청 파라미터 정리
          let requestApi = null;
          if (this.$route.query.type === "BOARD") {
            requestApi = boardApi.reportPost({
              ...params,
              boardId: this.data.boardDto.identifier,
              postId: this.data.id,
            });
          }

          if (this.$route.query.type === "COMMENT") {
            requestApi = boardApi.reportComment({
              ...params,
              boardId: this.data.boardDto.identifier,
              postId: this.data.id,
              id: this.$route.params.commentData.id,
            });
          }

          if (this.$route.query.type === "REVIEW") {
            requestApi = degreeApi.learnReportReview({
              ...params,
              degreeId: this.$route.params.degreeId,
              reviewId: this.data.id,
            });
          }

          if (this.$route.query.type === "REVIEW_MICRO") {
            requestApi = microDegreeApi.learnReportReview({
              ...params,
              degreeId: this.$route.params.degreeId,
              reviewId: this.data.id,
            });
          }

          if (this.$route.query.type === "CHECKLIST_COMMENT") {
            requestApi = checklistApi.reportComment(
              {
                ...params,
                postId: this.$route.params.data.postId,
              },
              this.$route.params.data.id
            );
          }

          const result = await requestApi;
          if (result) {
            // 요청 이후 처리
            this.$router.go(-1);
            this.$snackOpen({
              contents: this.$t("3807"),
            });
          }
        } catch (error) {
          console.log("Report error : ", error);
        }
      }
    },
  },
};
</script>
    
    
<style scoped>
.warning {
  color: #fc5356 !important;
}

.selected-outline {
  border-color: var(--WhiteHigh2) !important;
}

.input-color {
  caret-color: var(--WhiteHigh2) !important;
  color: var(--WhiteHigh2) !important;
}

.mdc-text-field .mdc-text-field__input {
  caret-color: var(--WhiteHigh2) !important;
}
</style>